import { TestingCreditsPlan } from '../testing_credits_plans/types';
import { ProductId } from '../types/productId';

export const defaultTestingCreditsPlan = {
  displayName: 'Email Testing 0',
  name: ProductId.SG_X_EMAIL_TESTING_0_V1,
  price: 0,
  count: 0,
} as TestingCreditsPlan;
